import store from './store';

import { LAYOUT_RESIZE } from './store/actions';

import debounce from 'lodash/debounce';

const TIMEOUT = 10;

(function _init() {
   window.addEventListener('resize', debounce(_onResize, TIMEOUT), false);
   _onResize();

   function _onResize() {
      store.dispatch(LAYOUT_RESIZE, { w: window.innerWidth, h: window.innerHeight });
   }
})();
